export default "__VITE_ASSET__DC__3sOT__"